import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Feedback, FeedbackMessage} from '../_types/feedback';
import {fetchAllPages} from '../_utils/http-params';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {
    private api: string = `${environment.apiUrl}/feedback`;

    constructor(private http: HttpClient) {
    }

    sendMessage(message: string, isAnonymous: boolean = false, community_id?: number): Observable<Feedback> {
        return this.http.post<Feedback>(`${this.api}/contact-us/`, {message, is_anonymous: isAnonymous, community_id});
    }

    getAllMessages(search?: string | null, reviewed?: string, community?: number): Observable<Feedback[]> {
        let params: HttpParams = new HttpParams();
        if (search) {
            params = params.append('search', search);
        }
        if (reviewed && reviewed != 'All') {
            params = params.append('reviewed', reviewed == 'Resolved');
        }
        if (community && community != 0) {
            params = params.append('community', community);
        }
        return fetchAllPages<Feedback>(this.http, `${this.api}/contact-us/`, 100, params);
    }

    deleteMessage(id: number): Observable<void> {
        return this.http.delete<void>(`${this.api}/contact-us/${id}/`);
    }

    editMessage(id: number, body: any): Observable<any> {
        return this.http.patch<void>(`${this.api}/contact-us/${id}/`, body);
    }

    getThreadMessages(id: number): Observable<FeedbackMessage[]> {
        return this.http.get<FeedbackMessage[]>(`${this.api}/contact-us/${id}/messages/`);
    }

    addThreadMessage(id: number, body: string): Observable<FeedbackMessage> {
        return this.http.post<FeedbackMessage>(`${this.api}/contact-us/${id}/messages/`, {body});
    }
}
